import { useState } from "react";
import Images from "../../../media/images";
import AOS from "aos";
import "aos/dist/aos.css";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { login } from "../../../features/auth/authSllice";
import { reset } from "../../../features/auth/authSllice";
import { ToastContainer } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadingButton from "../../../components/loadingButton/LoadingButton";
import "react-toastify/dist/ReactToastify.min.css";

const StaffLogin = () => {
  const [passVisibility, setPassVisibility] = useState(true);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const handleVisibility = () => {
    setPassVisibility((prev) => !prev);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, isLoading, isError, isSuccess, detail } = useSelector(
    (state) => state.auth
  );

  const handleOnChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (isError) {
      toast.error(detail);
    }

    if (isSuccess || user) {
      navigate("/");
    }
    dispatch(reset());
  }, [user, isError, isSuccess, detail, navigate, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { username, password } = formData;
    const userData = {
      email_or_phone: username,
      password,
    };
    if (username === "" && password === "") {
      toast.error("Please fill all the required fields");
    } else {
      dispatch(login(userData));
    }
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <>
      <div className="max-w w-full -mb-20">
        <ToastContainer theme="colored" />
        <div className="bg-primary-green grid grid-cols-1 items-stretch lg:grid-cols-2">
          <div className="flex flex-col items-center justify-center rounded-br-[100px] bg-gradient-to-t from-teal-500 via-teal-300 to-sky-300 p-2 md:!p-10">
            <div
              className="mt-10 flex w-full flex-col rounded-tl-[100px] rounded-tr-md rounded-br-[100px] rounded-bl-md bg-white py-20 shadow-2xl"
              data-aos="flip-up"
              data-aos-duration={500}
            >
              <div className="flex items-center justify-center">
                <img
                  src={Images.logo}
                  className="h-32 w-32"
                  alt=""
                  data-aos="fade-down"
                  data-aos-duration={1000}
                />
              </div>
              <div className="">
                <h1 className="text-primary-red mt-3 text-center text-2xl font-bold">
                  Staff Login
                </h1>
                <form onSubmit={handleSubmit}>
                  <div className="flex flex-col px-4 md:!px-20">
                    <input
                      type="text"
                      placeholder="Username"
                      className="border-primary-blue mt-3 w-full rounded-lg border-2 py-2 px-3"
                      name="username"
                      onChange={handleOnChange}
                    />
                    <div className="relative  flex justify-center mt-6 items-center">
                      <input
                        id="password"
                        type={`${passVisibility ? "password" : "text"}`}
                        name="password"
                        onChange={handleOnChange}
                        placeholder="Password"
                        // value={formData.password}
                        className="border-primary-blue  w-full rounded-lg border-2 py-2 px-3"
                      />
                      {passVisibility ? (
                        <span
                          onClick={handleVisibility}
                          className="absolute  right-0 cursor-pointer select-none pr-3"
                        >
                          <img src={Images.eyeOpen} alt="" />
                        </span>
                      ) : (
                        <span
                          onClick={handleVisibility}
                          className="absolute  right-0 cursor-pointer select-none pr-3"
                        >
                          <img src={Images.eyeClose} alt="" />
                        </span>
                      )}
                    </div>
                    <a href="" className="mt-3">
                      <span className="text-text-paragraph text-sm underline">
                        Forgot password?
                      </span>
                    </a>
                    <button
                      type="submit"
                      className="hover:bg-primary-red animation mt-8 rounded-md bg-red-500 py-2 px-4 text-center font-bold text-white"
                    >
                      {isLoading ? <LoadingButton /> : "Login"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="bg-primary-green">
            <div className="flex items-center justify-center p-5 md:p-20">
              <img
                src={Images.carosel3}
                alt=""
                className="h-full w-full rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StaffLogin;
